import { computed, onMounted, onUnmounted, ref } from 'vue';

export default function useResponsive() {
  const width = ref(window.innerWidth);
  const isMobile = computed(() => width.value < 1200);

  const updateWidth = (entries: ResizeObserverEntry[]) => {
    if (entries.length && entries[0])
      width.value = window.innerWidth;
  };

  const document = window.document.body;
  const observer = new ResizeObserver(updateWidth);

  onMounted(() => {
    observer.observe(document);
  });

  onUnmounted(() => {
    observer.unobserve(document);
  });

  return {
    width,
    isMobile,
  };
}
